"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chartisan = exports.ChartisanHooks = void 0;
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "ChartisanHooks", { enumerable: true, get: function () { return hooks_1.Hooks; } });
var chart_js_1 = __importDefault(require("chart.js"));
var Chartisan_1 = require("./Chartisan");
/**
 * Base chart class for ChartJS.
 */
var Chartisan = /** @class */ (function (_super) {
    __extends(Chartisan, _super);
    function Chartisan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Helper to mutate an array manually (this is used
     * because ChartJS can only handle animations when the
     * original array is modified).
     */
    Chartisan.mutateArray = function (dest, src, action) {
        var i;
        for (i = 0; i < src.length; i++) {
            if (i < dest.length) {
                if (action) {
                    action(dest, src, i);
                    continue;
                }
                dest[i] = src[i];
                continue;
            }
            dest.push(src[i]);
        }
        while (i < dest.length)
            dest.pop();
    };
    /**
     * Formats the data of the request to match the data that
     * the chart needs (according to the desired front-end).
     */
    Chartisan.prototype.formatData = function (response) {
        return {
            type: 'bar',
            data: {
                labels: response.chart.labels,
                datasets: response.datasets.map(function (_a) {
                    var name = _a.name, values = _a.values;
                    return ({
                        label: name,
                        data: values,
                    });
                }),
            },
            options: {},
        };
    };
    /**
     * Renews the canvas for another chart to be used.
     */
    Chartisan.prototype.renewCanvas = function () {
        if (this.canvas)
            this.body.removeChild(this.canvas);
        this.canvas = document.createElement('canvas');
        this.canvas.style.width = '100%';
        this.canvas.style.height = '100%';
        this.body.appendChild(this.canvas);
    };
    /**
     * Handles a successful response of the chart data.
     */
    Chartisan.prototype.onUpdate = function (data) {
        if (this.chart)
            this.chart.destroy();
        this.renewCanvas();
        this.chart = new chart_js_1.default(this.canvas, data);
    };
    /**
     * Handles a successful response of the chart data
     * in the background (possibly, updating the values
     * of the chart without creating a new one).
     */
    Chartisan.prototype.onBackgroundUpdate = function (data, options) {
        var _a, _b;
        if (this.chart) {
            // Merge chart options
            this.chart.options = __assign(__assign({}, this.chart.options), data.options);
            // Update labels
            if (this.chart.data.labels && ((_a = data.data) === null || _a === void 0 ? void 0 : _a.labels)) {
                Chartisan.mutateArray(this.chart.data.labels, data.data.labels);
            }
            // Update datasets
            if (this.chart.data.datasets && ((_b = data.data) === null || _b === void 0 ? void 0 : _b.datasets)) {
                Chartisan.mutateArray(this.chart.data.datasets, data.data.datasets, function (dest, src, i) {
                    Chartisan.mutateArray(dest[i].data, src[i].data);
                });
            }
            this.chart.update(options);
        }
        else {
            this.onUpdate(data);
        }
    };
    /**
   * Destroys the chart instance if any.
   */
    Chartisan.prototype.onDestroy = function () {
        if (this.chart)
            this.chart.destroy();
    };
    /**
     * This returns a base 64 encoded string of the
     * chart in its current state.
     */
    Chartisan.prototype.toImage = function () {
        var _a;
        return (_a = this.chart) === null || _a === void 0 ? void 0 : _a.toBase64Image();
    };
    /**
     * Returns an HTML string of a legend for that chart.
     * The legend is generated from the legendCallback in the options.
     */
    Chartisan.prototype.legend = function () {
        var _a, _b;
        return (_b = (_a = this.chart) === null || _a === void 0 ? void 0 : _a.generateLegend()) !== null && _b !== void 0 ? _b : undefined;
    };
    return Chartisan;
}(Chartisan_1.Chartisan));
exports.Chartisan = Chartisan;
if (typeof window !== 'undefined') {
    window.Chartisan = Chartisan;
    window.ChartisanHooks = hooks_1.Hooks;
}
